import { createFetch } from '@vueuse/core'
import { defineStore } from 'pinia'

import router from '@/router'
import i18n from '@/libs/i18n'
import { noteModuleRefusal } from '@/libs/license'
import { PrintError } from '@/libs/toast'
import { useAppStore } from '@/stores/app'

export const useFetchStore = defineStore('fetch', () => {
    const appStore = useAppStore()

    const fetch = createFetch({
        baseUrl: '/api/pms/v1',
        options: {
            beforeFetch({ options }) {
                options.headers = new Headers(options.headers)
                options.headers.set('Authorization', `Bearer ${appStore.getJWT()}`)

                return { options }
            },
            async onFetchError(ctx) {
                // The hotel has not bought this module. Noticed here, in the one place
                // every call passes through, rather than in each screen: whichever call
                // happens to be first — the centres, the calendar, GET /me — is refused
                // the same way, and the portal has to stop rather than draw an empty day.
                //
                // Before the 401 branch and separate from it: this is a 403, nobody is
                // signed out for it, and there is nothing to sign in to.
                noteModuleRefusal(ctx.response?.status, ctx.data)

                // A refused sign-in is not an expired session. The login screen says
                // "wrong username or password" itself, and adding "your session has
                // expired" beside it tells somebody who mistyped a password that
                // something else went wrong too.
                if (ctx.response?.status === 401 && appStore.isLoggedIn()) {
                    // Say why. On a phone in a corridor a rejected session looks like
                    // the room refusing to start, and the housekeeper presses the button
                    // again instead of signing in.
                    PrintError(i18n.global.t('errors.session_expired'))

                    appStore.setLogout()
                    await router.push({ name: 'login' })
                }

                return ctx
            },
        },
    })

    return { fetch }
})
